import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzTableModule } from "ng-zorro-antd/table";
import { INZorroOutput } from "../../../core/models/common";
import { CustomDateFormatPipe } from "../../../core/pipes/custom-date-format.pipe";
import { MaterialModule } from "../../../core/shared/material.module";

@Component({
  selector: "app-expandable-table",
  standalone: true,
  imports: [
    NzButtonModule,
    NzTableModule,
    NzCheckboxModule,
    CommonModule,
    FormsModule,
    MatIconModule,
    CustomDateFormatPipe,
    MaterialModule
  ],
  templateUrl: "./expandable-table.component.html",
  styleUrl: "./expandable-table.component.scss",
})
export class ExpandableTableComponent implements OnChanges {
  @Input() columns: any = [];
  @Input() data: any = [];
  @Input() options: any = {};
  @Output() handleActions = new EventEmitter<INZorroOutput>();
  @Output() onRowSelect = new EventEmitter<any>();

  isAllChecked = false;
  pageIndex: any = 1;
  isIndeterminate = false;
  displayData: any;
  selectedRows: any[] = [];
  defaultOptions: any = {
    pageSize: 10,
    showPagination: true,
    showPageSizeChanger: true,
  };
  contextMenuIndex: number | null = null;
  contextMenuPosition = { x: 0, y: 0 };
  index: any;
  selectR: boolean = false;
  selectedRow: any;

  ngOnInit() {
    this.options = { ...this.defaultOptions, ...this.options };

    // Ensure `this.data` is an array
    this.data = Array.isArray(this.data) ? this.data : [];
    this.data = this.data.map((record: any) => ({ ...record }));
    // Set displayData based on pagination
    if (this.options.showPagination) {
      this.displayData = [...(this.data?.slice(0, this.options.pageSize) ?? [])];
    } else {
      this.displayData = [...this.data]; // Show all data if pagination is disabled
    }
    // this.displayData = [...this.data?.slice(0, this.options.pageSize)];
  }

  selectAllRows() {
    this.isAllChecked = true;
    // this.isIndeterminate = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes["data"] &&
      changes["data"].currentValue !== changes["data"].previousValue
    ) {
      this.updateDisplayData();
    }
  }

  updateDisplayValue(): void {
    this.data = Array.isArray(this.data) ? this.data : [];

    const start = (this.pageIndex - 1) * this.options?.pageSize;
    const end = this.pageIndex * this.options?.pageSize;
    this.displayData = [...(this.data?.slice(start, end) ?? [])];
  }

  onSelectAll(event: any): void {
    this.isAllChecked = event.target.checked;
    this.isIndeterminate = false;
    this.data.forEach((record: any) => (record.select = event.target.checked));
    this.onRowSelect.emit({
      type: "rowSelect",
      data: this.data,
    });
    console.log(this.data.filter((record: any) => record.select));
  }

  // onRowSelectChange(): void {
  //   const allSelected = this.displayData.every((record: any) => record.select);
  //   const anySelected = this.displayData.some((record: any) => record.select);
  //   this.isAllChecked = allSelected;
  //   this.isIndeterminate = !allSelected && anySelected;
  //   this.onRowSelect.emit({
  //     type: "rowSelect",
  //     data: this.data.filter((record: any) => record.select),
  //   });
  //   console.log(this.data.filter((record: any) => record.select));
  // }
  onRowSelectChange(event: any, row: any): void {
    let currentRow = this.data.find((item: any) => item.id === row.id);

    if (currentRow) {
      currentRow = { ...currentRow, select: event }; // Cloning ensures immutability issues are avoided
      this.data = this.data.map((item: any) =>
        item.id === row.id ? currentRow : item
      );
    }

    // let currentRow = this.data.filter((item: any) => item.id == row.id)[0];
    // currentRow.select = event;
    // const allSelected = this.data.every((record: any) => record.select);
    // const anySelected = this.data.some((record: any) => record.select);
    // this.isAllChecked = allSelected;
    // this.isIndeterminate = !allSelected && anySelected;
    this.onRowSelect.emit({
      type: "rowSelect",
      data: this.data.filter((record: any) => record.select),
    });
  }
  onPageSizeChange(newPageSize: number): void {
    this.options.pageSize = newPageSize;
    this.updateDisplayData();
  }

  onPageIndexChange(newPageIndex: number): void {
    this.pageIndex = newPageIndex;
    this.updateDisplayData();
  }

  updateDisplayData(): void {
    const startIndex = (this.pageIndex - 1) * this.options.pageSize;
    const endIndex = startIndex + this.options.pageSize;
    this.displayData = [...this.data.slice(startIndex, endIndex)];
  }

  getNestedData(row: any, key: string) {
    if (!key) return "";
    let res = key.split(".").reduce((acc, part) => acc && acc[part], row) || "";
    if (!res) {
    }
    return res;
  }

  getString(data: any) {
    return JSON.stringify(data);
  }

  capitalizeFirstLetter(text: string): string {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  emitAction(type: string, data: any, event?: any, actionType?: string) {
    if (type === "textarea") {
      const updatedValue = (event.target as HTMLTextAreaElement).value;
      const updatedRow = { ...data.row };
      updatedRow[data.column.key] = updatedValue;
      data.row = updatedRow;
    }
    if (type === "thumb-feedback") {
      if (event == 1) {
        // Ensure feedbackEnabled is added or set to true
        if (
          !Object.prototype.hasOwnProperty.call(data.row, "feedbackEnabled")
        ) {
          data.row = Object.assign({}, data.row, { feedbackEnabled: true });
          data.row = Object.assign({}, data.row, { iconClicked: 1 });
        } else {
          data.row.feedbackEnabled = true;
          data.row.iconClicked = 1;
        }
        //on thumbs down show text area

        const updatedValue = (event.target as HTMLTextAreaElement)?.value;
        const updatedRow = { ...data.row };
        updatedRow[data.column.key] = updatedValue;
        data.row = updatedRow;
      } else if (event == 0) {
        if (
          !Object.prototype.hasOwnProperty.call(data.row, "feedbackEnabled")
        ) {
          data.row = Object.assign({}, data.row, { feedbackEnabled: false });
          data.row = Object.assign({}, data.row, { iconClicked: 0 });
        } else {
          data.row.feedbackEnabled = false;
          data.row.iconClicked = 0;
        }
      }
    }

    this.handleActions.emit({
      type,
      data,
      actionType,
    });
  }

  getGroupClassName(list: any) {
    return `col-md-${12 / list.length}`;
  }

  expandSet = new Set<number>();
  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  onExpandToggle(row: any) {
    row.expand = !row.expand;
  }

  openContextMenu(type: string, data: any, event?: any, actionType?: string) {
    this.index = this.getRowIndex(data.row);
    this.contextMenuIndex =
      this.contextMenuIndex === this.index ? null : this.index;
    this.contextMenuPosition = { x: event.clientX, y: event.clientY + 5 }; // Set menu position
  }

  getRowIndex(data: any): number {
    // console.log(this.data.indexOf(data));
    return this.data.indexOf(data);
  }

  handleContextMenuAction(event: MouseEvent, action: string): void {
    this.contextMenuIndex = null;
    console.log("abc");
  }
}
